import ReactDOM from 'react-dom';
import VideoJS from 'video.js';
import MyErrorDisplay from './MyErrorDisplay';

const BaseErrorDisplay = VideoJS.getComponent('ErrorDisplay');

class ErrorDisplay extends BaseErrorDisplay {
  constructor(player: any, options: any) {
    super(player, options);

    this.mountReactComponent = this.mountReactComponent.bind(this);

    player.ready(() => this.mountReactComponent(options));

    this.on('dispose', () => ReactDOM.unmountComponentAtNode(this.el()));
  }

  mountReactComponent(options: any) {
    ReactDOM.render(<MyErrorDisplay bridge={this} {...options} />, this.el());
  }

  createEl() {
    return VideoJS.dom.createEl('div', {
      className:
        'vjs-error-display vjs-modal-dialog intelligence-error-display',
    });
  }
}

export default ErrorDisplay;
